var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepSanctionsCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6719 18.7516H4.83435C4.37389 18.7508 4.00083 18.3777 4 17.9172V17.2405C4.00577 15.3145 5.56604 13.7549 7.49195 13.75H13.0143C14.9402 13.7549 16.5004 15.3145 16.5062 17.2405V17.9172C16.5054 18.3777 16.1323 18.7508 15.6719 18.7516Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2533 10.4989C8.39036 10.4989 6.87943 8.98997 6.87696 7.127C6.87449 5.26402 8.3814 3.75108 10.2444 3.74611C12.1073 3.74116 13.6223 5.24605 13.6298 7.10901C13.6325 8.00658 13.2781 8.86839 12.6447 9.50434C12.0113 10.1403 11.1509 10.4981 10.2533 10.4989Z",
    fill: "#3158F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3164 24.3586H13.4414C12.0952 24.3586 11.0039 23.2673 11.0039 21.9211V17.0461C11.0039 15.6999 12.0952 14.6086 13.4414 14.6086H18.3164C19.6626 14.6086 20.7539 15.6999 20.7539 17.0461V21.9211C20.7539 23.2673 19.6626 24.3586 18.3164 24.3586Z",
    fill: "#3158F2",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3356 17.656L14.9648 19.0268L16.7926 19.9407L15.4218 21.3115",
    stroke: "#F1F3F4",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepSanctionsCheck);
export default __webpack_public_path__ + "static/media/pep_sanctions_check.9518939fb326f6bc7bd0a438231c1276.svg";
export { ForwardRef as ReactComponent };